import { render, staticRenderFns } from "./m_majorPlayerPage.vue?vue&type=template&id=4de5027e&scoped=true"
import script from "./m_majorPlayerPage.vue?vue&type=script&lang=js"
export * from "./m_majorPlayerPage.vue?vue&type=script&lang=js"
import style0 from "./m_majorPlayerPage.vue?vue&type=style&index=0&id=4de5027e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de5027e",
  null
  
)

export default component.exports